var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuggestionImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 98,
    viewBox: "0 0 137 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.094 68.6051L127.366 92.9162",
    stroke: "#E6570E",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.421 68.6595L103.039 92.8617",
    stroke: "#E6570E",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.567 62.4094C134.098 66.8619 130.799 75.3594 116.981 83.1747C101.38 78.4988 96.0338 70.776 94.3416 66.5172C93.695 64.9889 93.5432 64.1127 93.591 63.8376C92.9751 58.6312 96.8812 53.6386 102.432 53.1799C107.982 52.7211 113.407 56.4907 114.023 61.6971C113.407 56.4907 117.313 51.4981 122.863 51.0394C128.414 50.5806 133.838 54.3502 134.454 59.5566C134.749 59.6075 134.854 60.7588 134.567 62.4094Z",
    fill: "#04C700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 31.0457 8.95431 40 20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.95431 0 0 8.9543 0 20Z",
    fill: "#FFB858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.167 46.0877C38.3808 48.347 36.4606 51.9076 40.6744 54.1669C44.8883 56.4261 46.8085 52.8655 51.0223 55.1247C55.2361 57.384 53.3159 60.9446 57.5297 63.2039C61.7435 65.4631 63.6637 61.9025 67.8775 64.1617C72.0914 66.421 70.1712 69.9816 74.385 72.2409",
    stroke: "#E6570E",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4653 33.1508C45.6792 35.4101 43.759 38.9707 47.9728 41.23C52.1866 43.4892 54.1068 39.9286 58.3206 42.1878C62.5344 44.4471 60.6142 48.0077 64.8281 50.267C69.0419 52.5263 70.9621 48.9656 75.1759 51.2248C79.3897 53.4841 77.4695 57.0448 81.6833 59.304",
    stroke: "#E6570E",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7634 20.2139C52.9772 22.4732 51.057 26.0338 55.2709 28.2931C59.4847 30.5523 61.4049 26.9917 65.6187 29.2509C69.8325 31.5102 67.9123 35.0709 72.1261 37.3301C76.34 39.5894 78.2602 36.0287 82.474 38.288C86.6878 40.5472 84.7676 44.1079 88.9814 46.3671",
    stroke: "#E6570E",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestionImg);
export default __webpack_public_path__ + "static/media/suggestion-img.a4e373646f2eaf4041f8a4b410728302.svg";
export { ForwardRef as ReactComponent };